<template>
    <div
        :class="{ 'lb-creation-card': showControls }"
        @mouseleave="showToolbar = false"
        @mouseover="showToolbar = true"
    >
        <div class="lb-box is-large">
            <div class="lb-card-content">
                <slot name="message"></slot>
                <div v-if="model.title" :class="{ field: isEdition }">
                    <textarea
                        v-if="showControls"
                        v-model="content.title"
                        :class="{ 'is-static': !showControls }"
                        :readonly="!showControls"
                        :placeholder="$t('creation.title_hint')"
                        class="input card-header-title is-size-5"
                        type="text"
                    />
                    <div v-else class="level is-mobile px-3 py-4">
                        <div class="level-left is-shrinkable">
                            <div class="level-item is-shrinkable">
                                <p
                                    class="card-header-title title is-paddingless is-size-5 is-block"
                                >
                                    {{ content.title }}
                                </p>
                            </div>
                        </div>
                        <div v-if="content.owner" class="level-right">
                            <div class="level-item">
                                <p
                                    :data-tooltip="content.owner.name"
                                    class="image is-24x24 has-tooltip-bottom"
                                >
                                    <img
                                        :src="content.owner.avatar"
                                        class="is-rounded lb-avatar"
                                        referrerpolicy="no-referrer"
                                    />
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <input-rich-text
                    v-if="
                        (showControls && model.description) ||
                        content.description
                    "
                    v-model="content.description"
                    :editable="showControls"
                    class="has-text-left lb-card-text"
                />
                <object-card-tags v-if="content.tags" :tags="content.tags" />
                <object-card-media
                    :show-controls="showControls"
                    :location.sync="content.location"
                    :images.sync="content.images"
                    :files.sync="content.files"
                    :embed.sync="content.embed"
                    :audio.sync="content.audio"
                    :video.sync="content.video"
                    :url.sync="content.url"
                    @edit="
                        showControls &&
                            $emit('addElement', { type: $event.type })
                    "
                />
                <object-card-related
                    v-if="model.related"
                    v-show="isEdition || isCreation"
                    :show-creation="showControls"
                    :answers.sync="content.answers"
                    :answer-type.sync="content.answerType"
                />
                <div
                    v-if="hasAccess && showToolbar"
                    class="buttons has-addons is-centered toolbar"
                >
                    <a
                        v-if="!showControls"
                        class="button is-dark"
                        @click.stop="enableEdition"
                    >
                        <span class="icon is-small">
                            <i class="fas fa-edit" />
                        </span>
                    </a>
                    <a
                        v-if="isEdition || isCreation"
                        class="button is-dark"
                        @click.stop="$emit('save')"
                    >
                        <span class="icon is-small">
                            <i class="fas fa-save" />
                        </span>
                    </a>
                    <a
                        class="button is-dark"
                        @click.stop="$emit('delete', content)"
                    >
                        <span class="icon is-small">
                            <i class="fas fa-trash" />
                        </span>
                    </a>
                </div>
            </div>
            <draggable
                v-if="showControls"
                v-model="pendingMedia"
                v-t="'creation.drag_content_hint'"
                :disabled="!isCreation && !isEdition"
                :group="{ name: 'media', pull: false, put: checkMove }"
                :order="false"
                class="lb-card-content_draggable_area"
                @add="emitAddEvent"
            >
                <!--button
          v-t="`creation.${media}`"
          v-for="media in mediaKeys"
          :data-mediatype="`${media}`"
          :key="media"
          :class="`lb-toolbar-button_${media}`"
          @click="$emit('addElement', { type: media })"
        /-->
            </draggable>
        </div>
    </div>
</template>

<script>
import ObjectCardMedia from '@/components/ObjectCardMedia';
import ObjectCardRelated from '@/components/ObjectCardRelated';
import ObjectCardTags from '@/components/ObjectCardTags';
import vClickOutside from 'v-click-outside';
import InputRichText from '@/components/InputRichText';
import draggable from 'vuedraggable';
import _ from 'underscore';
export default {
    name: 'ObjectCardSimplified',
    components: {
        ObjectCardMedia,
        ObjectCardRelated,
        ObjectCardTags,
        InputRichText,
        draggable,
    },
    directives: {
        clickOutside: vClickOutside.directive,
    },
    props: {
        content: {
            type: Object,
            default() {
                return {};
            },
        },
        model: {
            type: Object,
            default() {
                return {};
            },
        },
        isCreation: { type: Boolean, default: false },
        isEdition: { type: Boolean, default: false },
    },
    data() {
        return {
            showToolbar: false,
            showEdition: false,
            modalActive: false,
            pendingMedia: [],
        };
    },
    computed: {
        existingMedia() {
            return _.keys(this.mediaContent);
        },
        mediaKeys() {
            return _.union(
                this.existingMedia,
                _.pluck(this.pendingMedia, 'name')
            );
        },
        relatedContent: {
            get() {
                const relatedObjects = _.pluck(this.model.related, 'name');
                return _.pick(this.content, relatedObjects);
            },
            set() {
                console.log('here set related content');
            },
        },
        mediaContent() {
            const mediaObjects = _.pluck(this.model.media, 'name');
            return _.pick(this.content, mediaObjects);
        },
        hasAccess() {
            if (this.isCreation) {
                return true;
            }
            return this.content.accessLevel == 'administrator';
        },
        showControls() {
            return this.isEdition || this.isCreation;
        },
    },
    methods: {
        emitAddEvent() {
            this.$emit('addElement', { type: this.pendingMedia.shift().name });
        },
        enableEdition() {
            this.$emit('edit');
            this.showEdition = true;
        },
        checkMove(to, from, element) {
            return !_.contains(
                _.pluck(this.mediaKeys, 'name'),
                element.dataset.mediatype
            );
        },
        onClickOutside() {
            console.log('clickOutside simplified');
            if (_.isEmpty(this.content)) {
                console.log('content is empty, emitin cancel');
                return this.$emit('cancel');
            }
            if (this.showControls) {
                console.log('showControls is active, emitin clickOutside');
                this.$emit('clickOutside');
            } else {
                //console.log('canceling');
                //this.$emit('cancel');
            }
        },
        openModal(e) {
            this.$emit('addElement', e.type);
        },
    },
};
</script>

<style scoped>
.box {
    width: 30rem;
    min-width: 20rem;
    position: relative;
}
.toolbar {
    position: absolute;
    top: -20px;
    right: 10px;
}
.lb-card-text {
    padding: 12px;
    padding-top: 0;
    overflow-wrap: break-word;
}

.card-header-title {
    overflow-wrap: break-word;
}
textarea {
    min-height: 80px;
    resize: vertical;
}
</style>
